import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {ProcessMappingStepInput} from './ProcessMappingStepInput';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class ProcessMappingStep extends BasicEntity {
code: string;
description: TranslatedEmb;
inputs: ProcessMappingStepInput[];
label: TranslatedEmb;
level: number | null;
orderedInputs: ProcessMappingStepInput[];
processCode: string;
visionCode: string;
}

